import { render, staticRenderFns } from "./remit0.vue?vue&type=template&id=a075b216&scoped=true&"
import script from "./remit0.vue?vue&type=script&lang=js&"
export * from "./remit0.vue?vue&type=script&lang=js&"
import style0 from "./remit0.vue?vue&type=style&index=0&id=a075b216&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a075b216",
  null
  
)

export default component.exports